"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var TableColumn_1 = require("./TableColumn");
var TableCell = function (_a) {
    var children = _a.children, isSelected = _a.isSelected, alignment = _a.alignment;
    var tableCellClasses = (0, classnames_1.default)('tabular-content__cell', {
        'tabular-content__cell--selected': isSelected,
    });
    var tableCellContainerClasses = (0, classnames_1.default)('tabular-content__cell__container', (0, TableColumn_1.convertAlignmentToClass)(alignment));
    return (React.createElement("td", { className: tableCellClasses },
        React.createElement("span", { className: tableCellContainerClasses }, children)));
};
exports.TableCell = TableCell;
exports.TableCell.defaultProps = {
    isSelected: false,
};
exports.TableCell.propTypes = {
    alignment: PropTypes.oneOf(Object.values(TableColumn_1.Alignment)),
    isSelected: PropTypes.bool,
};
